import { SB, searchableComputedProperty } from '@play-co/replicant';
import type { State } from '../State';
import { cardsGetTradeableCards, cardsIsEnabled } from './cards.getters';
import type { CardId } from './cards.ruleset';

export const cardsProperties = {
  cardsCollectionEnabled: searchableComputedProperty(
    SB.boolean(),
    (state: State) => cardsIsEnabled(state),
  ),

  cardsTradeableCardIds: searchableComputedProperty(
    SB.array(SB.string()),
    (state: State, api) =>
      (
        Object.keys(cardsGetTradeableCards(state, api.date.now())) as CardId[]
      ).sort(),
  ),
};
